// src/components/Header.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { icons } from "../assets/icons";

const Header = () => {
  const navClass = ({ isActive }) =>
    `flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? "bg-indigo-500 text-white"
        : "text-gray-300 hover:bg-gray-700 hover:text-white"
    }`;

  return (
    <header className="bg-gray-900/80 text-white border-b border-gray-700/50 shadow-lg backdrop-blur-md sticky top-0 z-50">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          
          {/* UPDATED BRANDING: Using your specific styling for CryptoBag */}
          <NavLink
            to="/"
            aria-label="CryptoBag home"
            className="flex-shrink-0 flex items-center select-none"
          >
            <span className="font-black text-xl tracking-tighter">
              Crypto<span className="text-indigo-500">Bag</span>
            </span>
          </NavLink>

          {/* NAVIGATION LINKS */}
          <div className="flex space-x-2 sm:space-x-4">
            
            <NavLink to="/prices" className={navClass}>
              {icons.prices({ className: "w-5 h-5" })}
              <span className="hidden sm:inline">Prices</span>
            </NavLink>

            <NavLink to="/articles" className={navClass}>
              {icons.newspaper({ className: "w-5 h-5" })}
              <span className="hidden sm:inline">Articles</span>
            </NavLink>

            <NavLink to="/portfolio" className={navClass}>
              {icons.portfolio({ className: "w-5 h-5" })}
              <span className="hidden sm:inline">Portfolio</span>
            </NavLink>
            
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
